export default __webpack_public_path__ + "0c0a45ad8c538fa1713149f64d75da30.png";